import { useI18N } from "@sundae/react-hooks";
import { FC } from "react";
import { useTasteTestContext } from "../../../pages/TasteTestDetail/context";
import FadeInBasic from "../../FadeInView/FadeInBasic";
import TasteTestEmptyChartView from "../TasteTestEmptyChartView";
import TasteTestVestingScheduleChart from "../TasteTestVestingScheduleChart";

const TasteTestVestingSchedule: FC = () => {
  const { t } = useI18N("taste-test");
  const {
    state: { tasteTest },
  } = useTasteTestContext();

  /* -------------------------------------------------------------------------------------------------
   * Notice for no available Vesting Schedule Information
   * -----------------------------------------------------------------------------------------------*/
  if (!tasteTest?.vestingSchedule) {
    return (
      <TasteTestEmptyChartView
        title={t("detail.projectDetails.vestingSchedule.noData", { context: "title" })}
        description={t("detail.projectDetails.vestingSchedule.noData")}
      />
    );
  }

  return (
    <FadeInBasic className="relative flex flex-col gap-4 rounded-lg pt-4 lg:pt-0 xl:max-h-[28rem]">
      <div className="relative mx-auto grid w-full max-w-3xl gap-4 lg:col-span-2 lg:mx-0 lg:h-full">
        <TasteTestVestingScheduleChart />
      </div>
    </FadeInBasic>
  );
};

export default TasteTestVestingSchedule;
